import { Box, Text } from "@chakra-ui/react";
import {
  EhrName,
  EhrProvider,
  PatientOverview,
  PatientOverviewV2,
  SharedStateProvider,
} from "@metriport/shared-internal";
import { ossBaseUrlEClinicalWorks } from "../../../api/api";
import { useAppContext } from "../../contexts/app/index";
import { isMetriportDemoPatient } from "../../../shared/util";

export default function PatientPage() {
  const { state } = useAppContext();

  if (!state.isLoaded) {
    return null;
  }
  const isDashV2Enabled =
    state.featureFlags.cxsWithDashV2FeatureFlag ?? isMetriportDemoPatient(state.ehrPatientId);

  const ehrDetails = {
    ehrPatientId: state.ehrPatientId,
    name: EhrName.EClinicalWorks,
  };

  return (
    <Box>
      {state.ehrPatientId ? (
        <SharedStateProvider
          authToken={state.authToken}
          baseUrl={ossBaseUrlEClinicalWorks}
          ehrDetails={ehrDetails}
        >
          {isDashV2Enabled ? (
            // after v1 code is removed, remove ehrDetails from SharedStateProvider ^!
            <EhrProvider patientId={state.ehrPatientId} ehrDetails={ehrDetails}>
              <PatientOverviewV2 patientId={state.ehrPatientId} />
            </EhrProvider>
          ) : (
            <PatientOverview patientId={state.ehrPatientId} />
          )}
        </SharedStateProvider>
      ) : (
        <Text>No Patient</Text>
      )}
    </Box>
  );
}
